export default __webpack_public_path__ + "static/media/101-stream-water.991ea002.jpeg";